import { isEmptyEvData, isEvScoresAvailable, isEvEvaluationInProgress, shouldDisplayEvSharingMessageBloc, isEvSharingInProgress, isNewEvaluation, hasEcovadisError } from "services/common/EcovadisUtils";
import EcovadisStatusMessage from "./EcovadisStatusMessage";
import EcovadisProgress from "./EcovadisProgress/EcovadisProgress";
import EcovadisScores from "./EcovadisScoresDisplay/EcovadisScores";
import EcovadisErrorBloc from "./EcovadisErrorBloc";
const EcovadisPanel = ({ evData, onRiskChange = () => {} }) => {
  if(hasEcovadisError(evData)) return <EcovadisErrorBloc evData={evData} onRiskChange={onRiskChange} />;
  if(isEmptyEvData(evData) || shouldDisplayEvSharingMessageBloc(evData) || isNewEvaluation(evData)) return <EcovadisStatusMessage evData={evData} onRiskChange={onRiskChange}/>;
  if(isEvEvaluationInProgress(evData) || isEvSharingInProgress(evData)) return <EcovadisProgress evData={evData} onRiskChange={onRiskChange} />;
  if(isEvScoresAvailable(evData)) return <EcovadisScores evData={evData} onRiskChange={onRiskChange}/>;
  return "";
}

export default EcovadisPanel;